/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Decrypted inner payload of an VMUA approval request, as sent by SnapService. This object is returned by the parse endpoint and consumed by the approve endpoint.
 */
export interface VmuaApprovalRequest { 
    /**
     * Unique identifier for this approval request.
     */
    requestId?: string;
    /**
     * Identifier of the protected entity (e.g. vCenter UUID).
     */
    entityId?: string;
    /**
     * Type of the protected entity (e.g. VCENTER). Owned by SnapService.
     */
    entityType?: string;
    /**
     * Identifies the RSA key pair used to encrypt this request.
     */
    keyId?: string;
    /**
     * The operation requiring authorization (e.g. DELETE_PG_SNAPSHOTS). Owned by SnapService.
     */
    operation?: string;
    /**
     * Identifier of the specific resource being operated on.
     */
    resourceId?: string;
    /**
     * Human-readable name of the resource.
     */
    resourceName?: string;
    /**
     * User-friendly description of the operation shown in the approval UI.
     */
    message?: string;
    /**
     * Identity that triggered the operation (e.g. admin@vsphere.local).
     */
    initiatedBy?: string;
    /**
     * Timestamp when SnapService created this request.
     */
    issuedAt?: Date;
    /**
     * Timestamp after which this approval request is no longer valid.
     */
    expiresAt?: Date;
    /**
     * Operation-specific context as a free-form JSON object. Schema is defined and owned by SnapService.
     */
    operationContext?: { [key: string]: any; };
}

